module.exports = __webpack_public_path__ + "img/41c344ed3b6a147b23143c3c069a82b2.png";